import { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { User } from 'types/api/users.type';

import { useAppSelector } from 'redux/hooks';
import {
  getCurrentPage,
  getSize,
  getTableSorting,
  setTableCurrentPage,
  setTablePagination,
} from 'redux/slices/tableConfig';

import { usersDataService } from 'services/users.service';

import { useFetch } from 'hooks';

import { createColumns } from './columns.data';
import { createFilters } from './filters.data';

export const useDeleted = () => {
  const { register, handleSubmit, control, reset, setValue } = useForm();
  const [params, paramsSet] = useSearchParams({});
  const [deletedUsers, setDeletedUsers] = useState([]);

  const filters = createFilters();
  const columns = createColumns(setDeletedUsers);

  const page = useAppSelector(getCurrentPage);
  const size = useAppSelector(getSize);
  const sorting = useAppSelector(getTableSorting);

  const dispatch = useDispatch();

  const { isLoading, data } = useFetch(
    usersDataService.getDeletedUsers(page, size, params, sorting),
    [page, size, params, sorting]
  );

  useEffect(() => {
    if (data) {
      const { totalElements, empty } = data;

      if (totalElements > 0 && empty) {
        dispatch(setTableCurrentPage(0));
      } else {
        dispatch(setTablePagination({ totalPages: data?.totalPages }));
        const users = data.content?.map((item: User) => ({
          name: item?.name,
          surname: item?.surname,
          email: item?.email,
          timestamp: item?.timestamp,
          restore: item?.id,
        }));
        setDeletedUsers(users);
      }
    }
  }, [data]);

  const onSubmit = (filtersData: FieldValues) => {
    Object.keys(filtersData).forEach((key) => {
      if (filtersData[key] === undefined || filtersData[key] === '') {
        delete filtersData[key];
      }
    });

    paramsSet(filtersData);
  };

  return {
    deletedUsers,
    register,
    setValue,
    control,
    reset,
    filters,
    columns,
    onSubmit,
    handleSubmit,
    isLoading,
    params,
  };
};
